import styled from "styled-components";

export const VoucherCardFaceOriginalAmountBox = styled.div`
    font-size: 3rem;
    ${({theme}) => theme.font.presets.ultra};
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 2.4rem;
    }
`;
